var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLightGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C10.0449 5.47208e-06 16.2555 0.00196343 17.8135 0.420898C18.2382 0.53671 18.6253 0.761962 18.9355 1.07422C19.2457 1.38648 19.469 1.77483 19.582 2.2002C20.0001 3.77077 20 7.0459 20 7.0459C20 7.0895 19.9973 10.3306 19.582 11.8906C19.469 12.316 19.2457 12.7044 18.9355 13.0166C18.6252 13.3289 18.2382 13.5551 17.8135 13.6709C16.2554 14.0898 10.0449 14.0908 10 14.0908C10 14.0908 3.75097 14.0912 2.18652 13.6709C1.76177 13.5551 1.37476 13.3289 1.06445 13.0166C0.754179 12.7043 0.531033 12.3161 0.417969 11.8906C0.00267257 10.3307 1.88569e-05 7.08951 0 7.0459C0 7.0459 -0.000166509 3.77072 0.417969 2.2002C0.531038 1.77472 0.754157 1.38652 1.06445 1.07422C1.37476 0.761915 1.76177 0.536695 2.18652 0.420898C3.7506 0.000515259 10 0 10 0ZM7.9541 10.0195L13.1816 7.0459L7.9541 4.07227V10.0195Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLightGrayIcon);
export default __webpack_public_path__ + "static/media/youtube-light-gray-icon.beb2166b64149d2cfc11e83cf480da2a.svg";
export { ForwardRef as ReactComponent };